export default __webpack_public_path__ + "static/media/class-missions.38fafc8a.png";